import { Gift } from "lucide-react";
import { Link } from "react-router-dom";
import { getRefCode } from "@/lib/refCode";
import { Navbar1 } from "@/components/ui/navbar-1";
import Logo from "@/components/Logo";

/* Public site navigation.

   Route targets reuse the pages that already exist — the skill bundles map onto
   the /courses category filter, the not-yet-launched tracks onto /upcoming, and
   the paid tiers onto /package. Adjust the `to` values here as dedicated pages
   land; nothing else in the navbar needs to change. */

const NAV_LINKS = [
  { label: "Home", to: "/" },

  /* Both a destination and a dropdown: the label goes to the /learning overview,
     the chevron opens the mega-menu. */
  {
    label: "Learning",
    to: "/learning",
    menu: {
      groups: [
        {
          title: "Courses",
          items: [
            { label: "Learning Overview", to: "/learning" },
            { label: "Course Guide", to: "/courses" },
          ],
        },
        {
          title: "Skill Bundles",
          items: [
            { label: "Creator Economy", to: "/courses?category=content" },
            { label: "Marketing + Business", to: "/courses?category=marketing" },
            { label: "AI + Tech", to: "/courses?category=general" },
            { label: "Workplace Skills", to: "/courses?category=freelancing" },
          ],
        },
        {
          title: "Upcoming",
          items: [
            { label: "Freelancing", to: "/upcoming" },
            { label: "Dropshipping", to: "/upcoming" },
          ],
        },
        {
          title: "BYOB & Passes",
          items: [
            { label: "Astrology", to: "/upcoming" },
            { label: "Explorer Pass", to: "/explorer-pass" },
          ],
        },
      ],
    },
  },

  { label: "Membership", to: "/membership" },

  {
    label: "Portals",
    menu: {
      groups: [
        {
          title: "Portals",
          items: [
            { label: "Learner", to: "/dashboard", desc: "Your courses, progress and certificates." },
            { label: "Partner", to: "/partner/portal", desc: "Track referrals, payouts and performance." },
            { label: "Creator", to: "/partner", desc: "Teach on GENRYZ and grow your audience." },
          ],
        },
      ],
    },
  },

  { label: "About Us", to: "/about" },
];

export default function SiteHeader({ sticky = true }) {
  const refCode = getRefCode();

  return (
    <>
      {refCode && (
        <div className="bg-[var(--c1)]/10 border-b border-[var(--c1)]/30 text-[var(--c1)] py-2 px-4 text-center text-sm flex items-center justify-center gap-1.5">
          <Gift size={14} /> Referred by partner <strong>{refCode}</strong> — exclusive access unlocked
        </div>
      )}

      <nav className={`${sticky ? "sticky top-0" : ""} z-50 bg-transparent`}>
        <Navbar1
          logo={
            <Link to="/" aria-label="GENRYZ home" className="flex items-center">
              <Logo className="h-10 lg:h-12" />
            </Link>
          }
          links={NAV_LINKS}
          ctaLabel="Get Started"
          ctaHref="/dashboard"
          onCtaClick={() => window.open("/dashboard", "_blank", "noopener,noreferrer")}
        />
      </nav>
    </>
  );
}
